import React, { useState } from 'react';
import './HomeScreen.scss';
import { Button, Col, Container, Form, Image, InputGroup, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Header } from '../../components/Header/Header';
import { Subscribe as SubscribeModel } from '../../models/Subscribe';
import SubscribeService from '../../services/SubscribeService';
import { kpi } from '../../utils/images';

export const HomeScreen: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [showSuccess, toggleShowSuccess] = useState(false);
  const [showError, toggleShowError] = useState(false);

  const [validated, setValidated] = useState(false);

  const handleSubmit = async (event: any) => {
    const form = event.currentTarget;
    event.preventDefault();
    event.stopPropagation();
    setValidated(true);
    if (form.checkValidity() === true) {
      await subscribeToUpdates();
    }
  }
  const subscribeToUpdates = async () => {
    try {
      const subscription: SubscribeModel = {
        email
      };
      await SubscribeService.saveSubscription(subscription);
      toggleShowSuccess(true);
      setTimeout(() => {
        toggleShowSuccess(false);
      }, 4000);

      setEmail('');
      setValidated(false);
    } catch (error) {
      toggleShowError(true);
      setTimeout(() => {
        toggleShowError(false);
      }, 4000);
    }
  }
  return (
    <section>
      <Header/>
      <section>
        <Container className={'main-container'}>
          <Row>
            <Col md={5} sm={12}>
              <Row className={'text-start'}>
                <Col sm={12} className={'font-bold'}>
                  <h1 className="fade-in">Ensure teams’ efforts stay aligned with your CXO goals in real-time.</h1>
                  <h5 className="fade-in">Seamlessly align teams and optimize resources to bridge gaps, reduce disruptions, and meet revenue targets efficiently.</h5>
                </Col>
                <Col sm={12} className={'font-bold mt-4 justify-content-center d-flex'}>
                  <Button variant="primary" className="btn-block slide-left-right" id="button-addon2" onClick={() => navigate('/contact')}>
                    Book a demo
                  </Button>
                </Col>
                <Col sm={ 12 } xs={ 10 } md={ 12 } className="slide-left-right margin-top-100">
                  <h5 className="fade-in">Not ready for a demo?</h5>
                  <Form noValidate validated={ validated } onSubmit={ handleSubmit }>
                    <InputGroup className="mt-2" hasValidation>
                      <Form.Control
                        placeholder="Email address"
                        aria-label="Email address"
                        aria-describedby="basic-addon2"
                        type={ 'email' }
                        value={ email }
                        required
                        onChange={ (event) => setEmail(event.target.value) }
                      />
                      <Button variant="primary" id="button-addon2" type={ 'submit' }>
                        Keep me updated
                      </Button>
                      <Form.Control.Feedback type="invalid">
                        Please enter your valid email address.
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form>
                  { showSuccess && (
                    <Form.Text id="passwordHelpBlock" className={ 'text-primary fade-in' }>
                      You are subscribed for updates.
                    </Form.Text>
                  ) }
                  { showError && (
                    <Form.Text id="passwordHelpBlock" className={ 'text-danger fade-in' }>
                      An error occurred while subscribing. Please try again later!
                    </Form.Text>
                  ) }
                </Col>
              </Row>
            </Col>
            <Col md={7} sm={12}>
              <Image
                src={ kpi }
                width={'auto'}
                height={'100%'}
                className={'slide-right-left'}
              />
            </Col>
          </Row>
        </Container>
      </section>
    </section>
  )
}
